jQuery(document).ready(function () {
    // On page load, check the "Unscented" radio button and show its description
    const defaultScent = 'Unscented'; // Default scent
    jQuery('.product-form__input input.hello[value="' + defaultScent + '"]').prop('checked', true); // Select "Unscented"
    jQuery('div.product-description').hide(); // Hide all descriptions
    jQuery('div.product-description[data-scent-paragraph="unscented"]').show(); // Show "Unscented" description
    jQuery('button.product-form__submit.button.button--full-width.button--secondary').css('background', '#41a6df');
    jQuery('.product__tax.caption.rte').css('color', '#41a6df');
    jQuery('.product__tax.caption.rte a').css('color', '#41a6df');
    jQuery('img#wd_unscented').css('display', 'block'); jQuery('img#wd_lavender').css('display', 'none');
    jQuery('img#wd_aloevera').css('display', 'none'); jQuery('img#wd_cucumber').css('display', 'none');

    jQuery('img#logo_aloevera').css('display', 'none'); jQuery('img#logo_lavender').css('display', 'none');
    jQuery('img#logo_cucumber').css('display', 'none'); jQuery('img#logo_unscented').css('display', 'block');
    jQuery('.prod-left-desc p').css('color', '#41a6df');
    jQuery('.price__regular span.price-item.price-item--regular').css('color', '#41a6df');
    jQuery('section#ProductInfo-template--17570753708183__main h1').css('color', '#41a6df');
  

    jQuery(document).on('change','.product-form__input input[value="Unscented"]',function(){
          jQuery('div.product-description').hide();
          jQuery('div.product-description[data-scent-paragraph="unscented"]').show();
          jQuery('img#wd_unscented').css('display', 'block'); jQuery('img#wd_lavender').css('display', 'none'); 
          jQuery('img#wd_aloevera').css('display', 'none'); jQuery('img#wd_cucumber').css('display', 'none');
          jQuery('.prod-left-desc p').css('color', '#41a6df');
          jQuery('.prod-left-desc a').css('color', '#41a6df');
          jQuery('.prod-left-desc a').css('color', '#41a6df');
          jQuery('section#wipes-000 h2').css('color', '#41a6df');
          jQuery('section#wipes-000 .wipes00-left p').css('color', '#41a6df');
          jQuery('#sec-01').css('background', '#41a6df'); 
          jQuery('#sec-02 h2').css('color', '#41a6df');
          jQuery('#sec-02 h3').css('color', '#41a6df');
          jQuery('#sec-02 ul li').css('color', '#41a6df');
          jQuery('#sec-3').css('background', '#41a6df');
          jQuery('#sec-4 h2').css('color', '#41a6df');
          jQuery('#sec-4 p strong').css('color', '#41a6df');
          jQuery('#sec-4 p').css('color', '#41a6df');
          jQuery('button#ProductSubmitButton-template--17570753708183__main').css('background', '#41a6df');
          jQuery('img#logo_aloevera').css('display', 'none'); jQuery('img#logo_lavender').css('display', 'none');
          jQuery('img#logo_cucumber').css('display', 'none'); jQuery('img#logo_unscented').css('display', 'block');
          jQuery('.price__regular span.price-item.price-item--regular').css('color', '#41a6df');
          jQuery('.prod-left-desc p').css('color', '#41a6df');
          jQuery('.product__tax.caption.rte').css('color', '#41a6df');
          jQuery('.product__tax.caption.rte a').css('color', '#41a6df');
          jQuery('section#ProductInfo-template--17570753708183__main h1').css('color', '#41a6df');
    });
    jQuery(document).on('change','.product-form__input input[value="Aloe Vera"]',function(){
            jQuery('div.product-description').hide();
            jQuery('div.product-description[data-scent-paragraph="aloe-vera"]').show();
            jQuery('img#wd_aloevera').css('display', 'block'); jQuery('img#lavender').css('display', 'none'); 
            jQuery('img#wd_unscented').css('display', 'none'); jQuery('img#wd_cucumber').css('display', 'none');
            jQuery('.prod-left-desc p').css('color', '#6abf4b');
            jQuery('.prod-left-desc a').css('color', '#6abf4b');
            jQuery('section#wipes-000 h2').css('color', '#6abf4b');
            jQuery('section#wipes-000 .wipes00-left p').css('color', '#6abf4b');
            jQuery('#sec-01').css('background', '#6abf4b');
            jQuery('#sec-02 h2').css('color', '#6abf4b');
            jQuery('#sec-02 h3').css('color', '#6abf4b');
            jQuery('#sec-02 ul li').css('color', '#6abf4b');
            jQuery('#sec-3').css('background', '#6abf4b');
            jQuery('#sec-4 h2').css('color', '#6abf4b');
            jQuery('#sec-4 p strong').css('color', '#6abf4b');
            jQuery('#sec-4 p').css('color', '#6abf4b');
            jQuery('button#ProductSubmitButton-template--17570753708183__main').css('background', '#6abf4b');
            jQuery('img#logo_aloevera').css('display', 'block'); jQuery('img#logo_lavender').css('display', 'none');
            jQuery('img#logo_cucumber').css('display', 'none'); jQuery('img#logo_unscented').css('display', 'none');
            jQuery('.price__regular span.price-item.price-item--regular').css('color', '#6abf4b');
            jQuery('.prod-left-desc p').css('color', '#6abf4b');
            jQuery('.product__tax.caption.rte').css('color', '#6abf4b');
            jQuery('.product__tax.caption.rte a').css('color', '#6abf4b');
            jQuery('section#ProductInfo-template--17570753708183__main h1').css('color', '#6abf4b');
    });
  
    jQuery(document).on('change','.product-form__input input[value="Lavender"]',function(){
            jQuery('div.product-description').hide();
            jQuery('div.product-description[data-scent-paragraph="lavender"]').show();
            jQuery('img#wd_unscented').css('display', 'none'); jQuery('img#wd_lavender').css('display', 'block'); 
            jQuery('img#wd_aloevera').css('display', 'none'); jQuery('img#wd_cucumber').css('display', 'none'); 
            jQuery('.prod-left-desc p').css('color', '#6c51af');
             jQuery('.prod-left-desc a').css('color', '#6c51af');
             jQuery('section#wipes-000 h2').css('color', '#6c51af');
             jQuery('section#wipes-000 .wipes00-left p').css('color', '#6c51af');
            jQuery('#sec-01').css('background', '#6c51af');
            jQuery('#sec-02 h2').css('color', '#6c51af');
            jQuery('#sec-02 h3').css('color', '#6c51af');
            jQuery('#sec-02 ul li').css('color', '#6c51af');
            jQuery('#sec-3').css('background', '#6c51af');
            jQuery('#sec-4 h2').css('color', '#6c51af');
            jQuery('#sec-4 p strong').css('color', '#6c51af');
            jQuery('#sec-4 p').css('color', '#6c51af');
            jQuery('button#ProductSubmitButton-template--17570753708183__main').css('background', '#6c51af');
            jQuery('img#logo_aloevera').css('display', 'none'); jQuery('img#logo_lavender').css('display', 'block');
            jQuery('img#logo_cucumber').css('display', 'none'); jQuery('img#logo_unscented').css('display', 'none');
            jQuery('.price__regular span.price-item.price-item--regular').css('color', '#6c51af');
            jQuery('.prod-left-desc p').css('color', '#6c51af');
            jQuery('.product__tax.caption.rte').css('color', '#6c51af');
            jQuery('.product__tax.caption.rte a').css('color', '#6c51af');
            jQuery('section#ProductInfo-template--17570753708183__main h1').css('color', '#6c51af');
        });
    
        jQuery(document).on('change','.product-form__input input[value="Cucumber"]',function(){
            jQuery('div.product-description').hide();
            jQuery('div.product-description[data-scent-paragraph="cucumber"]').show();
            jQuery('img#wd_cucumber').css('display', 'block'); jQuery('img#wd_aloevera').css('display', 'none'); 
            jQuery('img#wd_unscented').css('display', 'none'); jQuery('img#wd_lavender').css('display', 'none');
            jQuery('.prod-left-desc p').css('color', '#009845');
            jQuery('.prod-left-desc a').css('color', '#009845');
            jQuery('section#wipes-000 h2').css('color', '#009845');
            jQuery('section#wipes-000 .wipes00-left p').css('color', '#009845');
            jQuery('#sec-01').css('background', '#009845');
            jQuery('#sec-02 h2').css('color', '#009845');
            jQuery('#sec-02 h3').css('color', '#009845');
            jQuery('#sec-02 ul li').css('color', '#009845');
            jQuery('#sec-3').css('background', '#009845');
            jQuery('#sec-4 h2').css('color', '#009845');
            jQuery('#sec-4 p strong').css('color', '#009845');
            jQuery('#sec-4 p').css('color', '#009845');
            jQuery('button#ProductSubmitButton-template--17570753708183__main').css('background', '#009845');
            jQuery('img#logo_aloevera').css('display', 'none'); jQuery('img#logo_lavender').css('display', 'none');
            jQuery('img#logo_cucumber').css('display', 'block'); jQuery('img#logo_unscented').css('display', 'none');
            jQuery('.price__regular span.price-item.price-item--regular').css('color', '#009845');
            jQuery('.prod-left-desc p').css('color', '#009845');
            jQuery('.product__tax.caption.rte').css('color', '#009845');
            jQuery('.product__tax.caption.rte a').css('color', '#009845');
            jQuery('section#ProductInfo-template--17570753708183__main h1').css('color', '#009845');
    });

});
